import React, { useEffect } from 'react';
import './config/firebase';
import RootNavigation from './navigation';
import { loadFonts } from './utils/fonts';
import { registerRootComponent } from 'expo';


export default function App() {
  loadFonts();
  return (
    <RootNavigation />
  );
}

registerRootComponent(App);